import { forwardRef } from "react";
import { FieldValues } from "react-hook-form";
import { PatternFormat } from "react-number-format";

import { FormTextField, FormTextFieldProps } from "../FormTextField";

export interface ZipCodeInputProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  extendedZipcode?: boolean;
  value: string;
}

// MUI hands a ref to whatever it renders as the input slot, so pass it on.
const FormZipcodeInput = forwardRef<HTMLInputElement, ZipCodeInputProps>(
  function FormZipcodeInput({ onChange, extendedZipcode, ...other }, ref) {
    return (
      <PatternFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: other.name,
              value: values.value,
            },
          });
        }}
        valueIsNumericString
        format={
          // eslint-disable-next-line no-nested-ternary
          extendedZipcode
            ? other.value?.length > 5
              ? `#####${!other.value.includes("-") ? "-" : ""}####`
              : "######"
            : "#####"
        }
      />
    );
  }
);

interface Props<TValues extends FieldValues>
  extends FormTextFieldProps<TValues> {
  extendedZipcode?: boolean;
}

export const FormZipcodeField = <TValues extends FieldValues>({
  extendedZipcode,
  InputProps,
  dataTestId,
  ...props
}: Props<TValues>) => (
  <FormTextField
    {...props}
    InputProps={{
      ...InputProps,
      inputComponent: FormZipcodeInput as never,
      inputProps: {
        ...InputProps?.inputProps,
        ...(dataTestId ? { "data-testid": dataTestId } : {}),
        extendedZipcode,
      },
    }}
  />
);
